import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './App.css';

import Welcome from './screens/Welcome';
import Signup from './screens/Signup';
import Login from './screens/Login';
import Profile from './screens/onboarding/Profile';
import BirthData from './screens/onboarding/BirthData';
import PathSelection from './screens/onboarding/PathSelection';
import QuickMatch from './screens/onboarding/QuickMatch';
import DeepSearch from './screens/onboarding/DeepSearch';
import Done from './screens/onboarding/Done';
import SwipeFaces from './screens/onboarding/SwipeFaces';
import BodyIntro from './screens/onboarding/BodyIntro';
import SwipeBodies from './screens/onboarding/SwipeBodies';
import SwipeDone from './screens/onboarding/SwipeDone';
import AttractionQuiz from './screens/onboarding/AttractionQuiz';
import AttractionPhotos from './screens/onboarding/AttractionPhotos';
import ProfileRead from './screens/onboarding/ProfileRead';
import Matches from './screens/Matches';
import MatchDetail from './screens/MatchDetail';
import Chats from './screens/Chats';
import ChatScreen from './screens/ChatScreen';
import Settings from './screens/Settings';
import PhotosSettings from './screens/PhotosSettings';
import SavedPartners from './screens/SavedPartners';
import Requests from './screens/Requests';
import PartnerTest from './screens/PartnerTest';
import AboutMe from './screens/AboutMe';
import BottomNav from './components/BottomNav';
import Preferences from './screens/onboarding/Preferences';
import Desires from './screens/Desires';

const SHOW_NAV = ['/matches', '/settings', '/chats', '/about', '/desires'];

function ResetSwipeTest() {
  const navigate = useNavigate();
  useEffect(() => {
    ['swipe_test_done', 'face_attraction', 'profile_read_shown', 'about_me_text'].forEach(k => localStorage.removeItem(k));
    navigate('/onboarding/swipe-faces', { replace: true });
  }, [navigate]);
  return null;
}

function IntakeNudge() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      if (localStorage.getItem('intake_path') !== 'quick') return;
      if (pathname.startsWith('/onboarding')) return;
      const dismissed = localStorage.getItem('intake_nudge_dismissed_at');
      if (dismissed && Date.now() - parseInt(dismissed) < 210_000) return;
      setVisible(true);
    };
    check();
    const id = setInterval(check, 30_000);
    return () => clearInterval(id);
  }, [pathname]);

  const dismiss = () => {
    localStorage.setItem('intake_nudge_dismissed_at', String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 90, left: '50%', transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)', maxWidth: 360,
      background: 'rgba(20,16,6,0.97)', border: '0.5px solid rgba(201,168,76,0.3)',
      padding: '14px 16px', zIndex: 100,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    }}>
      <div>
        <div style={{ fontSize: 12, color: 'var(--gold)', letterSpacing: 0.5 }}>Get better matches</div>
        <div style={{ fontSize: 11, color: 'var(--very-muted)', marginTop: 2 }}>Finish your full intake — 8 minutes</div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button
          onClick={() => { dismiss(); navigate('/onboarding/deep'); }}
          style={{
            padding: '7px 14px',
            background: 'rgba(201,168,76,0.1)',
            border: '0.5px solid rgba(201,168,76,0.4)',
            color: 'var(--gold)', fontSize: 12, cursor: 'pointer',
          }}
        >
          Finish →
        </button>
        <button
          onClick={dismiss}
          style={{
            background: 'none', border: 'none',
            color: 'var(--very-muted)', fontSize: 18,
            cursor: 'pointer', padding: '4px 6px', lineHeight: 1,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

function WakingToast() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => setVisible(e.detail.active);
    window.addEventListener('server-waking', handler);
    return () => window.removeEventListener('server-waking', handler);
  }, []);

  if (!visible) return null;

  return (
    <div className="waking-toast">
      <span className="spinner waking-spinner" />
      Just a moment — waking up the server...
    </div>
  );
}

function AppLayout() {
  const { pathname } = useLocation();
  const showNav = SHOW_NAV.includes(pathname) || pathname.startsWith('/match/') || pathname.startsWith('/chat/');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || ''}/health`).catch(() => {});
  }, []);

  return (
    <div className="app-wrap">
      <WakingToast />
      <IntakeNudge />
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding/profile" element={<Profile />} />
        <Route path="/onboarding/birth" element={<BirthData />} />
        <Route path="/onboarding/preferences" element={<Preferences />} />
        <Route path="/onboarding/path" element={<PathSelection />} />
        <Route path="/onboarding/quick" element={<QuickMatch />} />
        <Route path="/onboarding/deep" element={<DeepSearch />} />
        <Route path="/onboarding/swipe-faces" element={<SwipeFaces />} />
        <Route path="/onboarding/body-intro" element={<BodyIntro />} />
        <Route path="/onboarding/swipe-bodies" element={<SwipeBodies />} />
        <Route path="/onboarding/swipe-done" element={<SwipeDone />} />
        <Route path="/onboarding/attraction-quiz" element={<AttractionQuiz />} />
        <Route path="/onboarding/attraction-photos" element={<AttractionPhotos />} />
        <Route path="/onboarding/done" element={<Done />} />
        <Route path="/onboarding/read" element={<ProfileRead />} />
        <Route path="/onboarding/profile-read" element={<ProfileRead />} />
        <Route path="/matches" element={<Matches />} />
        <Route path="/match/:id" element={<MatchDetail />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/chat/:channelId" element={<ChatScreen />} />
        <Route path="/about" element={<AboutMe />} />
        <Route path="/desires" element={<Desires />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/photos" element={<PhotosSettings />} />
        <Route path="/settings/partners" element={<SavedPartners />} />
        <Route path="/settings/requests" element={<Requests />} />
        <Route path="/partner-test" element={<PartnerTest />} />
        <Route path="/reset-swipe-test" element={<ResetSwipeTest />} />
      </Routes>
      {showNav && <BottomNav />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}
